<template>
	<div class="dashboard-container">
		<div class="title" style="margin-top: 0;">评价管理</div>
		<el-tabs type="border-card" v-model="activeName">
			<el-tab-pane name="one" label="发型师评价">
				<div class="screen" style="margin-bottom: 15px;">
					<!-- 				<el-select  v-model="filter.data" size="small" style="width: 120px;margin-right:10px;" placeholder="请选择时间" clearable>
					<el-option v-for="item in datapotions" :key="item.value" :label="item.label" :value="item.value" />
				</el-select> -->
					<el-date-picker v-if="filter.data==0" value-format="yyyy-MM-dd"
						style="margin-right:10px; width: 300px;" size="small" v-model="filter.time" type="daterange"
						range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="getList()">
					</el-date-picker>
					<el-select clearable filterable size="small" v-model="filter.storeId"
						style="width:110px;margin-right:10px;" placeholder="全部店铺" @change="getList()">
						<el-option-group label="营业门店" class="store">
							<el-option v-for="item in storelist" :key="item.id" :label="item.title" :value="item.id">
							</el-option>
						</el-option-group>
						<el-option-group label="结业门店">
							<el-option v-for="item in storesEnd" :key="item.id" :label="item.title" :value="item.id">
							</el-option>
						</el-option-group>
					</el-select>
					<el-select clearable filterable size="small" v-model="filter.isSum" @change="getList()"
						style="width:130px;margin-right:10px;" placeholder="选择评价状态">
						<el-option v-for="item in option1" :key="item.value" :label="item.label" :value="item.value" />
					</el-select>
					<el-select clearable filterable size="small" v-model="filter.workerName" @change="getList()"
						style="width:120px;margin-right:10px;" placeholder="选择发型师">
						<el-option v-for="item in option2" :key="item.value" :label="item.label" :value="item.label" />
					</el-select>
					<el-select clearable filterable size="small" v-model="filter.score" @change="getList()"
						style="width:120px;margin-right:10px;" placeholder="评分">
						<el-option v-for="item in option3" :key="item.key" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
					<el-input size="small" style="width: 180px;margin-right: 10px;" v-model="filter.keyword"
						placeholder="输入订单号/用户手机号" @keydown.enter.native="getList()" clearable=""></el-input>
					<el-button size="small" type="primary" @click="getList();filter.pageNum=1; ">筛选</el-button>
					<el-button @click="clear()" size="small" style="margin-left: 10px;">重置</el-button>
					<div style="display: flex;float: right;">
						<el-button type="primary" size="small" @click="exports()">导出</el-button>
						<el-button @click="add=true" size="small" type="primary" style="margin-left: 10px;">刷评价
						</el-button>
					</div>
				</div>
				<el-table :data="tableData" style="width: 100%" v-loading="loading"
					:header-cell-style="{ background: '#F2F2F4', 'text-align': 'center' }"
					:cell-style="{'text-align': 'center', 'font-size': '14px'}">
					<el-table-column prop="orderNo" label="订单编号" width="120px"></el-table-column>
					<el-table-column prop="userNickname" label="用户名" width="150px"></el-table-column>
					<el-table-column prop="userPhone" label="手机号" width="120px"></el-table-column>
					<el-table-column prop="storeName" label="门店" width="150px"></el-table-column>
					<el-table-column prop="workerName" label="发型师" width="100px"></el-table-column>
					<el-table-column prop="type" label="服务" width="100px"></el-table-column>
					<el-table-column label="支付" width="80px">
						<template slot-scope="scope">
							￥{{ scope.row.payTotal}}
						</template>
					</el-table-column>
					<el-table-column label="评分" width="80px">
						<template slot-scope="scope">
							{{scope.row.score==5?"超级满意":""}}
							{{scope.row.score==4?"满意":""}}
							{{scope.row.score==3?"一般":""}}
							{{scope.row.score==2?"不满意":""}}
							{{scope.row.score==1?"非常差":""}}
						</template>
					</el-table-column>
					<el-table-column label="评价内容">
						<template slot-scope="scope">
							{{scope.row.comment==""?'无':scope.row.comment}}
						</template>
					</el-table-column>
					<el-table-column label="是否统计" width="80px">
						<template slot-scope="{row}">
							{{row.isSum==false?'不统计':'统计'}}
						</template>
					</el-table-column>
					<el-table-column prop="addTime" label="添加时间" width="100px"></el-table-column>
					<el-table-column width="150" label="操作">
						<template slot-scope="scope">
							<div class="flex">
								<div>
									<el-button type="text" @click="off(scope.row.id,scope.row.isShow)">
										{{ scope.row.isShow==1?'下架' :'上架' }}
									</el-button>
									<el-button type="text" @click="alertfix(0,scope.row.id)">编辑</el-button>
								</div>
								<div>
									<el-button type="text" @click="changeStatus(scope.row.id)">
										{{scope.row.status==0?'未回访':'已回访'}}
									</el-button>
									<el-button v-if="scope.row.isSum" type="text" @click="changeIsSum(scope.row)"
										style="color: red;">不统计</el-button>
									<el-button v-else type="text" @click="changeIsSum(scope.row)">统计</el-button>
								</div>
							</div>
						</template>
					</el-table-column>
				</el-table>
				<div class="pagechange">
					<el-pagination class="pages" @size-change="handleSizeChange" @current-change="handleCurrentChange"
						:current-page="filter.pageNum" :page-sizes="[10,20,50]" :page-size="filter.pageSize"
						layout="total, sizes, prev, pager, next, jumper" :total="filter.total">
					</el-pagination>
				</div>
			</el-tab-pane>
			<el-tab-pane name="two" label="意见反馈">
				<div style="">
					<el-date-picker v-model="filter2.date" type="daterange" value-format="yyyy-MM-dd"
						range-separator="至" size="small" placeholder="选择日期" start-placeholder="开始日期"
						end-placeholder="结束日期" style="margin-left: 10px;width: 300px;">
					</el-date-picker>
					<el-select clearable filterable size="small" v-model="filter2.store"
						style="width:150px;margin-left:10px;" placeholder="全部店铺">
						<el-option-group label="营业门店" class="store">
							<el-option v-for="item in storelist" :key="item.id" :label="item.title" :value="item.title">
							</el-option>
						</el-option-group>
						<el-option-group label="结业门店">
							<el-option v-for="item in storesEnd" :key="item.id" :label="item.title" :value="item.title">
							</el-option>
						</el-option-group>
					</el-select>
					<el-button @click="getList()" size="small" style="margin-left: 10px;">筛选</el-button>
					<el-button @click="clear()" size="small" style="margin-left: 10px;">重置</el-button>
					<el-button type="primary" @click="exp()" style="margin-left: 10px;" size="small">导出</el-button>
				</div>
				<!-- :header-cell-style="{ background: '#F2F2F4', 'font-weight': '800', 'font-size': '18px' }" -->
				<!-- 意见反馈 -->
				<el-table :data="oplist" style="width: 100%;">
					<el-table-column label="反馈类型" align="center" width="100px">
						<template slot-scope="scope">
							{{scope.row.type==null? "/" : scope.row.type}}
						</template>
					</el-table-column>
					<el-table-column label="门店" align="center" width="100px">
						<template slot-scope="scope">
							{{scope.row.store==null? "/" : scope.row.store}}
						</template>
					</el-table-column>
					<el-table-column prop="name" label="发型师" align="center" width="100px">
						<template slot-scope="scope">
							{{scope.row.name==null? "/" : scope.row.name}}
						</template>
					</el-table-column>
					<el-table-column prop="telephone" label="用户手机号" align="center" width="120px"
						style="padding-left: -10px;">
						<template slot-scope="scope">
							{{scope.row.telephone==null? "/" : scope.row.telephone}}
						</template>
					</el-table-column>
					<el-table-column prop="content" label="内容" style="text-align: left;"></el-table-column>
					<el-table-column prop="addTime" label="添加时间" align="center" width="180px"></el-table-column>
					<el-table-column label="操作" width="100px">
						<template slot-scope="scope">
							<el-button type="text" @click="change(scope.row.id)">{{scope.row.status==0?"回访" : "已回访"}}
							</el-button>
						</template>
					</el-table-column>
				</el-table>
				<div class="pagechange">
					<el-pagination class="pages" @size-change="handleSizeChange" @current-change="handleCurrentChange"
						:current-page="filter2.pageNum" :page-sizes="[10,20,50]" :page-size="filter2.pageSize"
						layout="total, sizes, prev, pager, next, jumper" :total="filter2.total">
					</el-pagination>
				</div>
			</el-tab-pane>

			<!-- <el-tab-pane name="three" label="报错反馈">
				<div style="">

					<el-date-picker v-model="filter3.date" type="daterange" value-format="yyyy-MM-dd"
						range-separator="至" size="small" placeholder="选择日期" start-placeholder="开始日期"
						end-placeholder="结束日期" style="margin-left: 10px;width: 300px;">
					</el-date-picker>
					<el-select clearable filterable size="small" v-model="filter3.storeName"
						style="width:150px;margin-left:10px;" placeholder="全部店铺">
						<el-option-group label="营业门店" class="store">
							<el-option v-for="item in storelist" :key="item.id" :label="item.title" :value="item.title">
							</el-option>
						</el-option-group>
						<el-option-group label="结业门店">
							<el-option v-for="item in storesEnd" :key="item.id" :label="item.title" :value="item.title">
							</el-option>
						</el-option-group>
					</el-select>
					<el-input type="text" v-model="filter3.id" placeholder="请输入剪发订单ID"
						style="width: 150px;margin-left: 10px;" size="small">
					</el-input>
					<el-input type="text" v-model="filter3.workerName" placeholder="请输入发型师名称"
						style="width: 150px;margin-left: 10px;" size="small">
					</el-input>

					<el-button @click="getReList()" size="small" style="margin-left: 10px;">筛选</el-button>
					<el-button @click="clear3()" size="small" style="margin-left: 10px;">重置</el-button>

				</div>
				<el-table :data="tableData3" style="width: 100%;">
					
					<el-table-column label="门店" align="center" width="200px">
						<template slot-scope="scope">
							{{scope.row.storeName==null? "/" : scope.row.storeName}}
						</template>
					</el-table-column>
					<el-table-column prop="workerName" label="发型师" align="center" width="200px">
						<template slot-scope="scope">
							{{scope.row.workerName==null? "/" : scope.row.workerName}}
						</template>
					</el-table-column>
					<el-table-column prop="id" label="订单ID" align="center" width="200px" style="padding-left: -10px;">
						<template slot-scope="scope">
							{{scope.row.id==null? "/" : scope.row.id}}
						</template>
					</el-table-column>

					<el-table-column prop="addTime" label="添加时间" align="center" width="200px">

					</el-table-column>
					<el-table-column prop="reportDetail" label="报错内容" style="text-align: left;">

					</el-table-column>
					
				</el-table>
				<div class="pagechange">
					<el-pagination class="pages" @size-change="handleSizeChange03"
						@current-change="handleCurrentChange03" :current-page="filter3.pageNum" :page-sizes="[10,20,50]"
						:page-size="filter3.pageSize" layout="total, sizes, prev, pager, next, jumper"
						:total="filter3.total">
					</el-pagination>
				</div>
			</el-tab-pane> -->
			<el-tab-pane name="fourth" label="大众点评">
				<div class="screen" style="margin-bottom: 15px;">
					<el-date-picker value-format="yyyy-MM-dd"
						style="margin-right:10px; width: 300px;" size="small" v-model="filter4.date" type="daterange"
						range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="getList()">
					</el-date-picker>
					<el-select clearable filterable size="small" v-model="filter4.storeId"
						style="width:110px;margin-right:10px;" placeholder="全部店铺" @change="getList()">
						<el-option-group label="营业门店" class="store">
							<el-option v-for="item in storelist" :key="item.id" :label="item.title" :value="item.id">
							</el-option>
						</el-option-group>
						<el-option-group label="结业门店">
							<el-option v-for="item in storesEnd" :key="item.id" :label="item.title" :value="item.id">
							</el-option>
						</el-option-group>
					</el-select>
					<el-select clearable filterable size="small" v-model="filter4.workerId" @change="getList()"
						style="width:120px;margin-right:10px;" placeholder="选择发型师">
						<el-option v-for="item in option2" :key="item.value" :label="item.label" :value="item.value" />
					</el-select>
					<el-button size="small" type="primary" @click="getList();filter4.pageNum=1; ">筛选</el-button>
					<div style="display: flex;float: right;">
						<el-button type="primary" size="small" @click="expDianPing()">导出</el-button>
					</div>
				</div>
				<el-table :data="tableData4" style="width: 100%" v-loading="loading"
					:header-cell-style="{ background: '#F2F2F4', 'text-align': 'center' }"
					:cell-style="{'text-align': 'center', 'font-size': '14px'}">
					<el-table-column prop="storeName" label="门店"></el-table-column>
					<el-table-column prop="workerName" label="发型师"></el-table-column>
					<el-table-column prop="addTime" label="上传时间"></el-table-column>
					<el-table-column label="图片" >
						<template slot-scope="scope">
						<div @click="imgListpush(scope.row.url)">
							 <el-image
							    style="width: 80px;height: 80px"
							    :src="scope.row.url" 
							    :preview-src-list="imgList"
								>
							  </el-image>
						</div>
							
						</template>
					</el-table-column>
				</el-table>
				<div class="pagechange">
					<el-pagination class="pages" @size-change="handleSizeChange" @current-change="handleCurrentChange"
						:current-page="filter4.pageNum" :page-sizes="[10,20,50]" :page-size="filter4.pageSize"
						layout="total, sizes, prev, pager, next, jumper" :total="filter4.total">
					</el-pagination>
				</div>
			</el-tab-pane>
		</el-tabs>
		<!-- 弹出提示框 -->
		<el-dialog title="查看详情" :visible.sync="dialogVisible" width="50%">
			<div class="showpingjia">
				<div class="showlist">
					<div class="showlist1">
						<div>订单号</div>
						<div>{{shows.orderNo}}</div>
					</div>
					<div class="showlist1">
						<div>用户名</div>
						<div>{{shows.userNickname}}</div>
					</div>
				</div>
				<div class="showlist">
					<div class="showlist1">
						<div>门店</div>
						<div>{{shows.storeName}}</div>
					</div>
					<div class="showlist1">
						<div>用户手机</div>
						<div>{{shows.userPhone}}</div>
					</div>
				</div>
				<div class="showlist">
					<div class="showlist1">
						<div>发型师</div>
						<div>{{shows.workerName}}</div>
					</div>
					<div class="showlist1">
						<div>是否首次购买</div>
						<div>{{ shows.firstStatus ?'是' :'否' }}</div>
					</div>
				</div>
				<!-- <div class="storepingjia" v-if="activeName=='one'">
					<div class="store_toitle">发型师评价</div>
					<div class="radios">
						<div>
							<el-radio v-model="shows.score" label="5">非常满意</el-radio>
						</div>
						<div>
							<el-radio v-model="shows.score" label="4">满意</el-radio>
						</div>
						<div>
							<el-radio v-model="shows.score" label="3">一般</el-radio>
						</div>
						<div>
							<el-radio v-model="shows.score" label="2">不满意</el-radio>
						</div>
						<div>
							<el-radio v-model="shows.score" label="1">非常不满意</el-radio>
						</div>
					</div>
				</div> -->
				<div class="storepingjia">
					<div class="store_toitle">文字评论</div>
					<div class="pingjiatrae">
						<textarea class="pingjiatrae_text" v-model="shows.comment"></textarea>
					</div>
				</div>
				<div class="storepingjia">
					<div class="store_toitle">图片评价</div>
					<upload v-model="imgurl" style="width:132px;height:132px" />
				</div>
				<div>
					<el-button @click="dialogVisible=false" size="small" style="margin-left:40%;margin-top: 15px;">取 消
					</el-button>
					<el-button v-if="parsershow" @click="preser" type="primary" size="small" style="margin-top: 15px;">
						保 存
					</el-button>
					<el-button v-if="!parsershow" disabled type="primary" size="small" style="margin-top: 15px;">
						保 存
					</el-button>
				</div>
			</div>
		</el-dialog>
		<el-dialog :visible.sync="add" title="刷评价" width="500px">
			<el-form inline style="width: 300px;" label-width="80px" label-position="left">
				<el-form-item label="门店">
					<el-select filterable size="small" v-model="filter.storeId" style="width:120px;margin-right:10px;"
						placeholder="请选择门店">
						<el-option-group label="营业门店" class="store">
							<el-option v-for="item in storelist" :key="item.id" :label="item.title" :value="item.id">
							</el-option>
						</el-option-group>
					</el-select>
				</el-form-item>
				<el-form-item label="发型师">
					<el-select filterable size="small" value-key="value" v-model="filter.worker"
						style="width:120px;margin-right:10px;" placeholder="选择发型师">
						<el-option v-for="(item,index) in option2" :key="item.value" :label="item.label" :value="item"
							:disabled="item.label=='全部发型师'?true:false" />
					</el-select>
				</el-form-item>
				<el-form-item label="次数">
					<el-input-number v-model="filter.pageNo" size="mini" placeholder="输入次数"></el-input-number>
				</el-form-item>
			</el-form>
			<div style="margin-left: 60%;">
				<el-button @click="add=false">取消</el-button>
				<el-button @click="addEv()" type="primary">保存</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
	import {
		url
	} from '../../utils/index.js'
	import upload from '../compents/upload/upload'
	import {
		export2Excel
	} from '../../common/js/util'
	export default {
		components: {
			upload
		},
		data() {
			return {
				url: url(),
				list: [],
				oplist: [],
				relist: [],
				loading: false,
				// 门店列表
				storelist: [],
				storesEnd: [],
				shows: {},
				imgList:[],//图片预览
				filter: {
					worker: {},
					workerName: "",
					storeId: "",
					data: "",
					time: "", //时间
					type: 0, //发型师
					score: '', //评分
					total: 0, //页面总数1
					startTime: "",
					endTime: "",
					pageNum: 1, //页码
					pageSize: 10, // 条数
					keyword: "", //订单号/用户手机号
					isSum: "", //是否统计
				},
				filter2: {
					workerName: "",
					storeId: "",
					store: "",
					data: "",
					date: "",
					time: "", //时间
					type: 0, //发型师
					total: 0, //页面总数1
					startTime: "",
					endTime: "",
					pageNum: 1, //页码
					pageSize: 10, // 条数
					keyword: "", //订单号/用户手机号
				},
				filter3: {
					workerName: "",
					id: "",
					storeId: "",
					storeName: "",
					data: "",
					date: "",
					time: "", //时间
					type: 0, //发型师
					total: 0, //页面总数1
					startTime: "",
					endTime: "",
					pageNum: 1, //页码
					pageSize: 10, // 条数
					keyword: "", //订单号/用户手机号
					reportDetail: "",
				},
				filter4: {
					workerId: '',
					storeId: '',
					date: "", //时间
					total: 0, //页面总数1
					startTime: "",
					endTime: "",
					pageNum: 1, //页码
					pageSize: 10, // 条数
				},
				dialogVisible: false, //用户打开弹出框
				data: '',
				//判断弹出框里面的保存按钮是否显示
				parsershow: "",
				imgurl: "",
				activeName: 'fourth',
				option1: [{
					value: true,
					label: '统计'
				}, {
					value: false,
					label: '不统计'
				}],
				option2: [{
					value: "",
					label: '选择发型师'
				}],
				option3: [{
					value: "5",
					label: "超级满意"
				}, {
					value: "4",
					label: "满意"
				}, {
					value: "3",
					label: "一般"
				}, {
					value: "2",
					label: "不满意"
				}, {
					value: "1",
					label: "非常差"
				}],
				tableData: [],
				tableData2: [],
				tableData3: [],
				tableData4: [], //大众点评
				add: false, //刷评价弹窗
				columns: [{
					title: '门店',
					key: 'storeName'
				}, {
					title: '发型师',
					key: 'workerName'
				}, {
					title: '图片',
					key: 'url'
				}, {
					title: '上传时间',
					key: 'addTime'
				}]
			}
		},
		watch: {
			activeName(val, oldVal) { //普通的watch监听
				this.getList()
			},
		},
		mounted() {
			this.getstore()
			this.gethairs()
			this.getList()
		
		},
		methods: {
			//重置意见筛选
			clear() {
				if (this.activeName == "one") {
					this.filter = {
						workerName: "",
						storeId: "",
						isSum: "", //是否统计
						data: "",
						time: "", //时间
						type: 0, //发型师
						score: '', //评分
						total: 0, //页面总数1
						startTime: "",
						endTime: "",
						pageNum: 1, //页码
						pageSize: 10, // 条数
						keyword: "", //订单号/用户手机号
					}
				} else if (this.activeName == "two") {
					this.filter2 = {
						store: "",
						date: "",
						startTime: "",
						endTime: "",
						pageNum: 1, //页码
						pageSize: 10, // 条数
						total: 0,
					}
				} else if (this.activeName == "three") {
					this.filter3 = {
						workerName: "",
						storeName: "",
						id: "",
						date: "",
						startTime: "",
						endTime: "",
						pageNum: 1, //页码
						pageSize: 10, // 条数
						total: 0,
					}
				} else if (this.activeName == "fourth") {
					this.filter4 = {
						workerId: "",
						storeId: "",
						date: "",
						startTime: "",
						endTime: "",
						pageNum: 1, //页码
						pageSize: 10, // 条数
						total: 0,
					}
				}
				this.getList()
			},
			// 下架
			off(id, show) {
				let arr = {
					id: id,
					isShow: show == 1 ? 2 : 1
				}
				this.$http.post("evaluate/updateStatus", JSON.stringify(arr)).then((res) => {
					if (res.body.code == "200") {
						if (arr.isShow == 1) this.$message.success("上架成功")
						if (arr.isShow == 2) this.$message.success("下架成功")
						this.getList()
					}
				})
			},
			//获取所有门店
			getstore() {
				this.$http.get("store/list?").then(function(res) {
					// res.body.data.rows = res.body.data.rows.filter(ele => ele.businessType == 0)
					if (res.body.code == "200") {
						res.body.data.forEach(ele => {
							if (ele.businessType == 1) {
								this.storesEnd.push(ele) //结业门店
							} else {
								this.storelist.push(ele) //营业门店
							}
						})
					}
				})
			},
			// 获取发型师列表
			gethairs() {
				this.$http.get("dWorker/query").then(function(res) {
					this.option2 = [{
						value: "",
						label: "全部发型师",
					}]
					if (res.body.code == "200") {
						for (let i in res.body.data) {
							let a = {
								value: res.body.data[i].id,
								label: res.body.data[i].name
							}
							this.option2.push(a)
						}
					}
				})
			},
			// 查找评价和意见
			getList() {
				this.loading = true
				// 查找评价列表
				if (this.activeName == "one") {
					if (this.filter.time != '') {
						this.filter.startTime = this.filter.time[0]
						this.filter.endTime = this.filter.time[1]
					}
					var a = {
						workerName: this.filter.workerName,
						storeId: this.filter.storeId,
						startTime: this.filter.startTime,
						endTime: this.filter.endTime,
						score: this.filter.score,
						pageNum: this.filter.pageNum,
						pageSize: this.filter.pageSize,
						keyword: this.filter.keyword,
						isSum: this.filter.isSum
					}
					this.$http.post("evaluate/findDEvaluate", JSON.stringify(a)).then(function(res) {
						if (res.body.code == "200") {
							this.filter.total = res.body.total;
							this.tableData = res.body.data;
						}
					})
				}
				// 查找意见列表
				if (this.activeName == "two") {
					if (this.filter2.date != '') {
						this.filter2.startTime = this.filter2.date[0]
						this.filter2.endTime = this.filter2.date[1]
					}
					let data = JSON.parse(JSON.stringify(this.filter2));
					if (data.workerName == '全部发型师') {
						data.workerName = ''
					}
					this.$http.post("opinion/list", JSON.stringify(data)).then(function(res) {
						if (res.body.code == "200") {
							this.filter2.total = res.body.total;
							this.tableData2 = res.body.data;
						}
					})
				}
				// 查找报错列表
				if (this.activeName == "three") {
					if (this.filter3.date != '') {
						this.filter3.startTime = this.filter3.date[0]
						this.filter3.endTime = this.filter3.date[1]
					}
					var a = "?pageNum=" + this.filter3.pageNum +
						"&pageSize=" + this.filter3.pageSize +
						"&storeName=" + this.filter3.storeName +
						"&workerName=" + this.filter3.workerName +
						"&id=" + this.filter3.id +
						"&startTime=" + this.filter3.startTime +
						"&endTime=" + this.filter3.endTime

					this.$http.get("evaluate/badOrder" + a).then(res => {
						this.tableData3 = res.body.data
						this.filter3.total = res.body.total
					})
				}
				//查找大众点评列表
				if (this.activeName == "fourth") {
					if (this.filter4.date != '') {
						this.filter4.startTime = this.filter4.date[0]
						this.filter4.endTime = this.filter4.date[1]
						// delete this.filter4.date
					}
					var a = {
						workerId: this.filter4.workerId,
						storeId: this.filter4.storeId,
						startTime: this.filter4.startTime,
						endTime: this.filter4.endTime,
						pageNum: this.filter4.pageNum,
						pageSize: this.filter4.pageSize
					}
					this.$http.post("evaluate/findDianPing", JSON.stringify(a)).then(function(res) {
						if (res.body.code == "200") {
							this.filter4.total = res.body.total;
							this.tableData4 = res.body.data;
						}
					})
				}
				this.loading =  false
			},
			//导出
			//导出发型师评价
			exports() {
				if (this.filter.workerName == '全部发型师') {
					this.filter.workerName = ''
				}
				if (this.activeName == "one") {
					// 把筛选条件转换
					if (this.filter.time != '') {
						this.filter.startTime = this.filter.time[0]
						this.filter.endTime = this.filter.time[1]
					}
					window.location.assign(this.url + "evaluate/exporDEvaluate?type=0&week=" + this.filter.week +
						"&month=" + this.filter.month +
						"&keyword=" + this.filter.keyword +
						"&yesterday=" + this.filter.yesterday +
						"&startTime=" + this.filter.startTime +
						"&endTime=" + this.filter.endTime +
						"&stylist=" + this.filter.stylist +
						"&storeId=" + this.filter.storeId +
						"&workerName=" + this.filter.workerName +
						"&score=" + this.filter.score +
						"&isSum=" + this.filter.isSum
					)
				}
			},
			//导出意见反馈
			exp() {
				window.location.assign(this.url + "opinion/export?startTime=" + this.filter2.startTime +
					"&endTime=" + this.filter2.endTime +
					"&store=" + this.filter2.store
				);
			},
			//导出报错反馈
			expRe() {
				//改接口
				window.location.assign(this.url + "evaluate/badOrder?startTime=" + this.filter3.startTime +
					"&endTime=" + this.filter3.endTime +
					"&storeName=" + this.filter3.storeName +
					"&id=" + this.filter3.id
				);
			},
			imgListpush(url){
				this.imgList = []
				this.imgList.push(url.toString())
				return this.imgList
			},
			//导出大众点评
			expDianPing() {
				export2Excel(this.columns, this.tableData4)
				// console.log(this.filter4)
				// var a="?"
				// if (this.filter4.date!='') {
				// 	this.filter4.startTime = this.filter4.date[0]
				// 	this.filter4.endTime = this.filter4.date[1]
				// 	a = a+"startTime=" + this.filter4.startTime + "&endTime=" + this.filter4.endTime
				// }
				// if(this.filter4.storeId!=''){
				// 	a = a+"&storeId=" + this.filter4.storeId
				// }
				// if(this.filter4.workerId!=''){
				// 	a = a+"&workerId=" + this.filter4.workerId
				// }
				// window.location.assign(this.url + "evaluate/expDianPing" + a );
			},
			//发型师评价编辑
			alertfix(i, id) {
				if (i == 0) {
					this.parsershow = true
				}
				if (i == 1) {
					this.parsershow = false
				}
				if (this.activeName == "one") {
					for (let a in this.tableData) {
						if (this.tableData[a].id == id) {
							this.shows = this.tableData[a]
							this.shows.score = this.shows.score.toString()
						}
					}
					this.dialogVisible = true;
				}
				if (this.activeName == "two") {
					for (let b = 0; b < this.tableData2.length; b++) {
						if (this.tableData2[b].id == id) {
							this.shows = this.tableData2[b]
							this.shows.score = this.shows.score.toString()
						}
					}
					this.dialogVisible = true
				}
				if (this.activeName == "three") {
					for (let c = 0; c < this.tableData3.length; c++) {
						if (this.tableData3[b].id == id) {
							this.shows = this.tableData3[c]
							this.shows.score = this.shows.score.toString()
						}
					}
					this.dialogVisible = true
				}
			},
			//发型师评价弹窗编辑保存
			preser() {
				this.$http.post("evaluate/updateDEvaluate", JSON.stringify(this.shows)).then(function(res) {
					if (res.body.code == "200") {
						this.filter2.total = res.body.total
						this.tableData2 = res.body.data
						this.dialogVisible = false
						this.$message.success("保存成功")
						this.getList()
					}
				})
			},
			// 意见反馈回访
			change(id) {
				this.$http.get("opinion/change" + "?id=" + id).then(res => {
					if (res.body.code == 200) {
						this.$message.success("回访成功");
						this.getList();
					}
				})
			},
			// 报错处理
			due(id) {
				this.$http.get("evaluate/badOrder" + "?id=" + id).then(res => {
					if (res.body.code == 200) {
						this.$message.success("处理成功");
						this.getList();
					}
				})
			},
			// 评价回访
			changeStatus(id) {
				this.$http.get("evaluate/change" + "?id=" + id).then(res => {
					if (res.body.code == 200) {
						this.$message.success("回访成功");
						this.getList();
					}
				})
			},
			//
			changeIsSum(row) {
				// 如果为统计则设置为不统计
				if (row.isSum) {
					this.$http.get("evaluate/changeSum" + "?id=" + row.id).then(res => {
						if (res.body.code == 200) {
							this.$message.success("评价设为不统计");
						}
					})
				} else {
					this.$http.get("evaluate/changeSum2" + "?id=" + row.id).then(res => {
						if (res.body.code == 200) {
							this.$message.success("评价设为统计");
						}
					})
				}
				this.getList();
			},
			addEv() {
				var a = "?workerId=" + this.filter.worker.value + "&workerName=" + this.filter.worker.label + "&pageNo=" +
					this.filter.pageNo + "&storeId=" + this.filter.storeId
				// console.log(a)
				// return
				this.$http.get("evaluate/add" + a).then(res => {
					if (res.body.code == 200) {
						this.$message.success("成功")
					} else {
						this.$message.error("系统异常")
					}
				})
			},
			handleSizeChange(val) {
				if (this.activeName == "one") {
					this.filter.pageSize = val
				}
				if (this.activeName == "two") {
					this.filter2.pageSize = val
				}
				if (this.activeName == "three") {
					this.filter3.pageSize = val
				}
				if (this.activeName == "fourth") {
					this.filter4.pageSize = val
				}
				this.getList()
			},
			handleCurrentChange(val) {
				if (this.activeName == "one") {
					this.filter.pageNum = val
				}
				if (this.activeName == "two") {
					this.filter2.pageNum = val
				}
				if (this.activeName == "three") {
					this.filter3.pageNum = val
				}
				if (this.activeName == "fourth") {
					this.filter4.pageNum = val
				}
				this.getList()
			}
		}
	}
</script>

<style scoped="scoped" lang="less">
	.dashboard-container {
		box-sizing: border-box;

		.title {
			font-size: 18px;
			font-family: Source Han Sans CN;
			font-weight: bold;
			color: #3e3e3e;
			margin-bottom: 15px;
		}

		.pagechange {
			margin-top: 20px;
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			align-items: center;
		}

		.showpingjia {
			width: 100%;
			padding: 25px;
			box-sizing: border-box;

			.pingjiatrae {
				width: 100%;
				height: 170px;
				background: #FFFFFF;
				border: 1px solid #A0A0A0;
				border-radius: 10px;
				box-sizing: border-box;
				padding: 20px;

				.pingjiatrae_text {
					width: 100%;
					height: 100%;
					border: none;
					resize: none;
				}
			}

			.showlist {
				margin-top: 40px;
				display: flex;
				width: 100%;

				&:nth-child(1) {
					margin-top: -20px;
				}

				.showlist1 {
					flex: 1;
					display: flex;

					>div:nth-child(1) {
						text-align: left;
						flex: 1;
						font-size: 16px;
						font-family: Source Han Sans CN;
						font-weight: 500;
						color: #3E3E3E;
					}

					>div:nth-child(2) {
						text-align: left;
						font-size: 16px;
						font-family: Source Han Sans CN;
						font-weight: 400;
						color: #6B6B6B;
						flex: 2;
						opacity: 0.8;
					}
				}
			}

			// 用户评价
			.store_toitle {
				font-size: 18px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #3E3E3E;
				margin-top: 20px;
				margin-bottom: 20px;
				margin-left: -22px;
			}

			.radios {
				width: 100%;
				display: flex;

				div {
					flex: 1;
				}
			}
		}
	}
	/deep/.el-select-dropdown__item {
		width:220px;
	}
</style>